import React from 'react';
import { useTranslation } from 'react-i18next';

const ContactSecTwo = ({ className = "space overflow-hidden" }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div 
        className="shape-mockup bg-gradient-shape1 contact-bg-gradient1" 
        data-top="-10%" 
        data-left="3%"
      ></div>
      <div className="container">
        <div className="row gy-4 justify-content-center">
          <div className="col-lg-4 col-md-6">
            <div className="contact-feature" data-cue="slideInUp">
              <div className="box-icon icon-btn">
                <i className="far fa-location-dot"></i>
              </div>
              <div className="media-body">
                <h3 className="box-title">{t('sections.contactSecTwo.address_title','Our Address')}</h3>
                <p className="box-text">
                  {t('sections.contactSecTwo.address','932 Dogwood Road, Chapel Hill, North Carolina')}
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="contact-feature" data-cue="slideInUp">
              <div className="box-icon icon-btn">
                <i className="far fa-address-book"></i>
              </div>
              <div className="media-body">
                <h3 className="box-title">{t('sections.contactSecTwo.contact_title','Contact Us')}</h3>
                <p className="box-text">
                  {t('sections.contactSecTwo.phone_label','Phone')}: <a href="tel:+1655778749">{t('sections.contactSecTwo.phone','+165-5577-8749')}</a>
                </p>
                <p className="box-text">
                  {t('sections.contactSecTwo.email_label','Email')}: <a href="mailto:info@secur.com">{t('sections.contactSecTwo.email','info@secur.com')}</a>
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="contact-feature" data-cue="slideInUp">
              <div className="box-icon icon-btn">
                <i className="far fa-clock"></i>
              </div>
              <div className="media-body">
                <h3 className="box-title">{t('sections.contactSecTwo.opening_title','Opening Hour')}</h3>
                <p className="box-text">{t('sections.contactSecTwo.opening_week','Mon - Sat: 10.00 AM - 4.00 PM')}</p>
                <p className="box-text">{t('sections.contactSecTwo.opening_sun','Sunday: Closed')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSecTwo;